export default __webpack_public_path__ + "static/media/wallets.96b87835.jpg";